import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default function QuestionsListMapping({
  style,
  items,
  ReplaceQuestion,
  index,
  isReplaceEnabled,
  handleOpenPreview,
}) {
  function decodeBase64Utf8(base64String) {
    return decodeURIComponent(escape(atob(base64String)));
  }

  return (
    <div className={style.childContainer}>
      <div className={style.chlildContentFristRow} style={{ marginBottom: '10px' }}>
        <p>
          <span className={style.questionListingLabel}>ID: </span>{' '}
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleOpenPreview(items?.question_id);
            }}
            className={style.idStyle}
          >
            {items?.question_id}
          </span>
        </p>
        {isReplaceEnabled && (
          <button
            onClick={() => ReplaceQuestion(items?.question_id, index)}
            className={`${style.duplicateButton} ${style.duplicateButton_new}`}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.0516 5.49951C15.3278 5.49951 15.5516 5.27565 15.5516 4.99951C15.5516 4.72337 15.3278 4.49951 15.0516 4.49951V5.49951ZM15.0516 4.49951H6.21873V5.49951H15.0516V4.49951ZM4.54102 5.99951V12.9995H5.54102V5.99951H4.54102ZM6.21873 14.4995H15.4327V13.4995H6.21873V14.4995ZM4.54102 12.9995C4.54102 13.9015 5.37197 14.4995 6.21873 14.4995V13.4995C5.76463 13.4995 5.54102 13.2021 5.54102 12.9995H4.54102ZM6.21873 4.49951C5.37197 4.49951 4.54102 5.09752 4.54102 5.99951H5.54102C5.54102 5.79693 5.76463 5.49951 6.21873 5.49951V4.49951Z"
                fill="#00ABFB"
              />
              <path
                d="M12.834 11.4995L15.0575 13.6392C15.2619 13.8359 15.2619 14.1631 15.0575 14.3598L12.834 16.4995"
                stroke="#00ABFB"
                strokeLinecap="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2384 7.49951C9.4066 7.49951 8.69922 8.15315 8.69922 8.99951V12.4996L9.69922 12.4997V8.99951C9.69922 8.7413 9.92233 8.49951 10.2384 8.49951H16.4734C16.7894 8.49951 17.0125 8.7413 17.0125 8.99951V17.9995C17.0125 18.2577 16.7894 18.4995 16.4734 18.4995H10.2384C9.92233 18.4995 9.69922 18.2577 9.69922 17.9995V15.4997L8.69922 15.4996V17.9995C8.69922 18.8459 9.4066 19.4995 10.2384 19.4995H16.4734C17.3051 19.4995 18.0125 18.8459 18.0125 17.9995V8.99951C18.0125 8.15315 17.3051 7.49951 16.4734 7.49951H10.2384ZM8.69922 14.4996L9.69922 14.4997V13.4997L8.69922 13.4996V14.4996Z"
                fill="#00ABFB"
              />
            </svg>
          </button>
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className={style.chlildContentSecondRow}>
          <span style={{ marginLeft: 0 }} className={style.sortChips}>
            {items?.primary_tag?.subject_tag}
          </span>
        </div>

        <div className={style.chlildContentSecondRow}>
          <p className={style.questionListingDiscription} style={{ margin: '5px 0px' }}>
            <div dangerouslySetInnerHTML={{ __html: decodeBase64Utf8(items?.compose_question) }}></div>
          </p>
        </div>
        <div style={{ marginLeft: -10 }} className={style.chlildContentSecondRow}>
          {items?.free_tags?.map((item) => (
            <span key={item.name} style={{ backgroundColor: '#F4F5F6' }} className={style.sortChips}>
              {item?.name}
            </span>
          ))}
        </div>
        <div className={style.chlildContentSecondRow}>
          <div className={style.questionListingLabelContainer}>
            <span className={style.questionListingLabel}>
              Author: <span style={{ color: 'black' }}>{items?.author}</span>
            </span>{' '}
            <svg width="10" height="10" viewBox="0 0 1 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.5" y1="-0.00927732" x2="0.499999" y2="15.9907" stroke="#C7CCD1" />
            </svg>
          </div>
          <div className={style.questionListingLabelContainer}>
            <span className={style.questionListingLabel}>
              Academic Year:<span style={{ color: 'black' }}> {items?.academic_year}</span>
            </span>{' '}
            <svg width="10" height="10" viewBox="0 0 1 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.5" y1="-0.00927732" x2="0.499999" y2="15.9907" stroke="#C7CCD1" />
            </svg>
          </div>
          <div className={style.questionListingLabelContainer}>
            <span className={style.questionListingLabel}>
              Created On:
              <span style={{ color: 'black' }}> {moment(items?.created_on).format('Do MMM YYYY')}</span>
            </span>{' '}
            <svg width="10" height="10" viewBox="0 0 1 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.5" y1="-0.00927732" x2="0.499999" y2="15.9907" stroke="#C7CCD1" />
            </svg>
          </div>
          <div className={style.questionListingLabelContainer}>
            <span className={style.questionListingLabel}>
              Type: <span style={{ color: 'black' }}>{items?.type}</span>
            </span>{' '}
            <svg width="10" height="10" viewBox="0 0 1 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.5" y1="-0.00927732" x2="0.499999" y2="15.9907" stroke="#C7CCD1" />
            </svg>
          </div>
          <div className={style.questionListingLabelContainer}>
            <span className={style.questionListingLabel}>
              LOD: <span style={{ color: 'black' }}>{items?.lod}</span>
            </span>{' '}
          </div>
        </div>
      </div>
    </div>
  );
}

QuestionsListMapping.propTypes = {
  ReplaceQuestion: PropTypes.func,
  index: PropTypes.any,
  isReplaceEnabled: PropTypes.any,
  items: PropTypes.shape({
    academic_year: PropTypes.any,
    author: PropTypes.any,
    compose_question: PropTypes.any,
    created_on: PropTypes.any,
    free_tags: PropTypes.shape({
      map: PropTypes.func,
    }),
    lod: PropTypes.any,
    primary_tag: PropTypes.shape({
      subject_tag: PropTypes.any,
    }),
    question_id: PropTypes.any,
    type: PropTypes.any,
  }),
  questionBankId: PropTypes.any,
  style: PropTypes.shape({
    childContainer: PropTypes.any,
    chlildContentFristRow: PropTypes.any,
    chlildContentSecondRow: PropTypes.any,
    duplicateButton: PropTypes.any,
    duplicateButton_new: PropTypes.any,
    idStyle: PropTypes.any,
    questionListingDiscription: PropTypes.any,
    questionListingLabel: PropTypes.any,
    questionListingLabelContainer: PropTypes.any,
    sortChips: PropTypes.any,
  }),
};
